import {InputType} from 'module/CustomField/util/CFInputType'
import {useDispatch, useSelector} from 'react-redux'
import {selMemoMap} from 'module/Memo/selector/MemoSelector'
import {getMemoSelectedSize, isMemoAutoAddActive} from 'module/Memo/util/MemoUtil'
import {DqElement} from 'module/Dq/searchDq'
import {getDqMemoKey} from 'module/Memo/util/MemoKey'
import {CustomFieldTO} from 'generated/JavaTO'
import {isMemorizable} from 'module/Memo/type/Memorizable'
import {memoAddAction, memoToggleAction} from 'module/Memo/action/MemoAction'
import {CFValue} from 'module/CustomField/type/CFType'
import {filterOption} from 'module/CustomField/component/input/ReactSelectComponent/FilterOption'


const EnabledInputTypes = [
	InputType.Dq,
	InputType.DqLabel,
	InputType.DqMulti,
	InputType.Kost,
]

interface Params {
	cfDef: CustomFieldTO
	modelValue: CFValue
	inputValue: string
}

export function useMemoDq(params: Params) {
	const {cfDef, modelValue, inputValue} = params
	const dispatch = useDispatch()
	const {dqKey, input} = cfDef
	const memoKey = getDqMemoKey(dqKey)
	let isEnabled = Boolean(dqKey?.trim() && EnabledInputTypes.includes(input as InputType))
	const dqMemoMap = useSelector(selMemoMap)
	const memoSize = isEnabled ? getMemoSelectedSize(cfDef) : 0
	if (!memoSize) isEnabled = false
	const autoAdd = isMemoAutoAddActive(cfDef)
	let memoElements: DqElement[] = !memoSize ? [] : (dqMemoMap?.[memoKey] || []).map(x => ({...x, memo: true}))
	const dispatchMemoAutoAddAction = (element: DqElement | undefined | null) => {
		if (!isEnabled && !autoAdd || !isMemorizable(element)) return
		dispatch(memoAddAction({memoKey: memoKey, element, sizeMax: memoSize}))
	}
	const dispatchMemoToggleAction = (element: DqElement | undefined | null) => {
		if (!isEnabled || !isMemorizable(element)) return
		dispatch(memoToggleAction({memoKey: memoKey, element, sizeMax: memoSize}))
	}
	memoElements = inputValue && inputValue !== modelValue ? memoElements.filter(e => filterOption(e, inputValue)) : memoElements
	return {memoEnabled: isEnabled, memoElements, dispatchMemoAutoAddAction, dispatchMemoToggleAction}
}